import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(_theme => ({
   itemText: {
      color: 'black',
   },
}));
